import { motion } from "framer-motion";
import React from "react";
// import { SplineElement } from "../Components";
// import Spline from "@splinetool/react-spline";

import ReactPng from "../assets/react.png";
import PytonPng from "../assets/python.png";
import JsPng from "../assets/javascript.png";
import ProfileSVG from "../assets/Images/profile2.svg"

const scaleVariants = {
    whileInView: {
        scale: [0, 1],
        opacity: [0, 1],
        transition: {
            duration: 1,
            // delay:0.1,
            ease: "easeInOut",
        },
    },
};

function Header() {
    return (
        <div>
            <div
                id="home"
                className="relative flex w-full h-full justify-evenly items-center flex-col md:flex-row !pt-24 md:p-8 p-3">
                <motion.div
                    whileInView={{ x: [-100, 0], opacity: [0, 1] }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="header_info flex flex-row justify-between h-full ">
                    <div className="select-none header_badge flex flex-col z-20 items-end md:p-5 !pt-2 !pb-2 p-4  rounded-lg bg_blur">
                        <div className="badge_cmp w-full ">
                            <p className="font-mono text-sm md:text-lg">
                                Hi, I am
                            </p>
                            <div className="font-face-p text-2xl md:text-3xl text-white">
                                Shubhankar
                            </div>
                        </div>

                        <div className="font-mono text-sm md:text-lg">
                            Developer|Freelancer
                        </div>
                    </div>
                </motion.div>

                {/* <img src={Profile} alt="" /> */}

                {/* <SplineElement className="scale-50"/> */}

                {/* <Spline
                className="!hidden lg:!flex md:scale-50 xl:scale-75 !m-0 !p-0"
                scene="https://prod.spline.design/ELos0TXWrbbSNK4P/scene.splinecode"
            /> */}

                <motion.div
                    // whileInView={{ opacity: [0, 1] }}
                    // transition={{ duration: 1, ease: "easeInOut" }}
                    className="header_img">
                    <img className=" p-4 " width={600} src={ProfileSVG} alt="" />
                </motion.div>
                <motion.div
                    variants={scaleVariants}
                    whileInView={scaleVariants.whileInView}
                    className="select-none flex md:flex-col justify-evenly items-start z-20 h-full md:m-4 ">
                    {[ReactPng, PytonPng, JsPng].map((circle, index) => (
                        <div
                            className={`${
                                index === 1
                                    ? " w-24 h-24 xl:w-36 xl:h-36 m-7   "
                                    : "w-16 h-16 xl:w-24 xl:h-24 "
                            } rounded-full bg_blur flex justify-center items-center `}
                            key={`circle-${index}`}>
                            <img
                                src={circle}
                                alt="circle"
                                className="w-2/3 h-2/3"
                            />
                        </div>
                    ))}
                </motion.div>
            </div>
            <motion.div
                whileInView={{ y: [50, 0], opacity: [0, 1] }}
                transition={{ duration: 1, delay: 0.5, ease: "easeInOut" }}
                className="font-mono text-center text-sm md:text-base p-2">
                "Your work is going to fill a large part of your life, and the
                only way to be truly satisfied is to love what you do" - Steve
                Jobs
            </motion.div>
        </div>
    );
}

export default Header;
